import React, {useState, useEffect} from 'react';
import {FormControl,InputLabel,Select as MaterialSelect ,
  Box,Typography, TextField} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
//import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
//import Alert from '@material-ui/lab/Alert';
import {DatePicker, MuiPickersUtilsProvider, TimePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import esLocale from "date-fns/locale/es";
import ModalTam from '../Generales/ModalTam';
import {toast} from 'react-toastify';
import {llamadaApiToken,llamaApiCargaToken,ErrorGeneral } from '../funciones/ClienteAxios';
import moment from "moment";
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'noWrap',
    //alignItems: 'center',
    flexDirection:"column"
  },
  wrapper: {
    //margin: theme.spacing(0),
    margiTop: 0,
    paddingTop:0,
    position: 'relative',
  },
 
  buttonGuardar:{color: green[500],},
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default function ModalNvoProveedor({modalAbierto,setModalAbierto,titulo, actualizar, auxRegis}) {  
  let history = useHistory();
  const classes = useStyles();
  const idusu= localStorage.getItem('UsuId');
  const source = axios.CancelToken.source();   
  const [aviso, setAviso] = useState(false);  
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');    
  const [registro,setRegistro]= useState({ auxId:0,  Domicilio:"", rfc:"",
                                          Alias:"", Razon:"", Responsable:"", email:"",
                                          Contacto:"", Folio:"", Estado:"", Municipio:""})          
  
  const [espera,setEspera]=useState(false);    
  const [listEstado, setListEstado]=useState([]);
  const [listMunicipio, setListMunicipio]=useState([]);  
  const { auxId,   Municipio, Estado, Domicilio, 
        rfc, Alias, Razon,Responsable, email,
        Contacto, Folio} = registro;          

  useEffect(()=>{
 
    getListEstado()    
  
    if (auxRegis && auxRegis.length !== 0 ) 
    { //console.log(auxRegis);
    
      setRegistro({...registro, auxId: auxRegis.Id, Domicilio:auxRegis.ProvDomId,
        Alias:auxRegis.Alias, Contacto:auxRegis.Contacto, Domicilio: auxRegis.Dir,
        email:auxRegis.Email, Folio:auxRegis.Folio, Razon:auxRegis.Razon, Responsable:auxRegis.Responsable,
        rfc:auxRegis.Rfc, Estado:auxRegis.EdoId, Municipio:auxRegis.MunId
       })
      
    }
    return () => {
      source.cancel();
    }

  },[])

  useEffect(()=>{
    if (Estado!=="") {
      
      getListMunicipio(Estado)
    }
  },[Estado])
 
  const getListEstado = () => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/maquinaria/ubicacion/estado";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListEstado(aux);                                      
      }         
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
  };   

  const getListMunicipio = (auxEdo) => {
    if (!auxRegis || auxRegis.length === 0 ) {
     setRegistro({...registro, Municipio:"", }) 
    }
     
    const data = qs.stringify({
      Usuario:idusu,
      Estado:auxEdo,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/maquinaria/ubicacion/estado/municipio";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListMunicipio(aux);                                      
      }         
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
  };   

  const registrarNvo=()=>{
    const data = qs.stringify({                            
        Usuario:idusu,
        Llave:auxId,
        Estado:Estado,
        Municipio:Municipio,
        Rfc:rfc.toUpperCase(),
        Alias:Alias,
        Razon:Razon,
        Responsable:Responsable,
        Domicilio:Domicilio,
        Email:email,
        Contacto:Contacto,
        Folio:Folio,    
        idDispositivo:'iu87ygubhjjij',
    });   
    const url = "/renta/proveedor/new-edit";
    function respuesta(aux) {
      if (aux.respuesta === 1) 
      {   let mensaje="Se registro correctamente "
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)           
        //setRegistroExitoso(true) 
        toast.success(mensaje,{
          pauseOnFocusLoss: false,                    
          toastId: `nvo-proveed${aux.mensaje}`
        })
        actualizar()
        setModalAbierto(false)
      }       
    }    
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source); 
  }  

  const mostrarAlertas =(auxMensaje)=>{ 
    setTipoAdvertencia("warning")
    let mensaje=auxMensaje            
    setMensaje(mensaje);
    setAviso(true)   
  } 

  function valNulos(auxMensaje,auxCampo) 
  {    let valida=false    
    if ( auxCampo !== '' && auxCampo !== '0' && auxCampo !==0 
        && auxCampo !== null && auxCampo!==" " ) 
    {   valida=true              
    }
    if (!valida) 
    {   mostrarAlertas(auxMensaje)
    }
    return valida
  }

  const validaDatos=(valor, mensaje)=>{
    let respuesta=false    
    if (valor!= null && valor!= '' && valor!= '0' && valor!== 0 ) 
    { respuesta=true     
    }
    else
    { 
      mostrarAlertas(mensaje)
    }
    return respuesta
  }

  function validaVariable(auxCampo,auxMensaje,auxTamanio) 
  { let respuesta=false
    if ( valNulos(auxMensaje,auxCampo) ) 
    { if (auxCampo.length>=auxTamanio ) 
      {                
        respuesta=true                    
      }else
      {            
        mostrarAlertas(`${auxMensaje}`) 
      }
    }        
    return respuesta;
  }

  function valBool(auxMensaje,auxCampo) 
  {    let valida=false    
    if ( auxCampo ) 
    {   valida=true              
    }
    if (!valida) 
    {   mostrarAlertas(auxMensaje)
    }
    return valida
  }


  
  const onChange = e =>
  {
    setRegistro({ ...registro, [e.target.name] : e.target.value })
  };

  const onChangeSelected = e =>
  {
    setRegistro({ ...registro, [e.target.name] : e.target.value })
  };

  const onChangeFolio = e =>
  { let expNopermitida = new RegExp('[$!?:%-({})/*=|]');
    //let expMenos = new RegExp('-');
    //let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9#_]');
    if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) ) 
        || e.target.value===' ' || e.target.value==='') 
    {    
      setRegistro({ ...registro, [e.target.name] : e.target.value  })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

  const onChangeMixto = e =>
  { let expNopermitida = new RegExp('[#_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9]');
    if (expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value)||e.target.value===' '||e.target.value==='') 
    {  
      setRegistro({
        ...registro,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

    const onChangeEmail = e =>
  { let expNopermitida = new RegExp('[#:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9@_.]');
    if (expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value)||e.target.value===' '||e.target.value==='') 
    {  
      setRegistro({
        ...registro,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

    const onChangeNumTel = e =>
	{ let expNopermitida= new RegExp('[A-Za-z$@#_&-+()/:;!?,<>=]');          
    let expMenos = new RegExp("'");
    let expMas = new RegExp('-+');     
    let expCadena = new RegExp('[.0-9$]');             
    if (  e.target.value.length<=10 &&( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
      && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
      || e.target.value===' '|| e.target.value==='') 
    {
      setRegistro({ ...registro,[e.target.name] : e.target.value })                   
    }		    
	}; 

  const onChangeNum = e =>
  { let expNopermitida = new RegExp('[#A-Za-z_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[0-9]');
    if (expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value)||e.target.value===' '||e.target.value==='') 
    {  
      setRegistro({
        ...registro,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

  const guardarParo = () => {
  
    if (//  valNulos( "Llenar campo de Folio/Clave ", Folio) &&
       valNulos("Seleccionar Estado",Estado ) && valNulos("Seleccionar Municipio",Municipio ) 
      && validaVariable(rfc, "Llenar campo de RFC (mayor o igual a 12 caracteres)",12)  
      && validaVariable(Alias, "Llenar campo de Alias (mayor a 3 caracteres)",3)    
      && validaVariable(Razon, "Llenar campo de Razón (mayor a 5 caracteres)",5)    
      && validaVariable(Responsable, "Llenar campo de Responsable (mayor a 5 caracteres)",5)      
      && validaVariable(Contacto, "Llenar campo de Teléfono de Contacto (mayor a 10 caracteres)",10)      
      && validaVariable(email, "Llenar campo de Email (mayor a 5 caracteres)",5)      
      && validaVariable(Domicilio, "Llenar campo de Domicilio (mayor a 3 caracteres)",3)
    ) 
    {         
      setAviso(false)                                                                                       
      //console.log(registro);
      
      registrarNvo()                                     
    }                           
  };

  return (
    <ModalTam  titulo={titulo} modalAbierto={modalAbierto} 
      setModalAbierto={setModalAbierto} guardarDatos={guardarParo} 
      mensaje={mensaje} tipoAdvertencia={tipoAdvertencia} 
      aviso={aviso} setAviso={setAviso} espera={espera} 
      setEspera={setEspera} tamanio="md" btnDesact={false}
    >    
    <form className={classes.root} noValidate autoComplete="off" fullWidth>     
   {/*  <Box width={"100%"} mb={1}>      
      <FormControl component="fieldset"  fullWidth>    
        <TextField id="outlinedCantidad" variant='outlined'           
          label="Folio/Clave"  size="small"  inputProps={{maxLength:50}}
          value={Folio} onChange={onChangeFolio}  
          name="Folio" fullWidth
        /> 
      </FormControl>
    </Box> */}
  
    <Box mb={2} mt={1}>
    { listEstado.length !== 0 ?
      <FormControl className={classes.formControl} size="small" style={{width:"12rem"}}  >
        <InputLabel htmlFor="age-native-simple">Estado</InputLabel>
        <MaterialSelect
          native value={Estado} onChange={onChangeSelected}
          inputProps={{ name: 'Estado', id: 'Estado',}}
        >
          <option aria-label="None" value="" />                     
          {listEstado.map((row,index) => (
            <option value={row.Id} key={index} >{row.Nom}</option>
          ))}   
        </MaterialSelect>
      </FormControl>     
    :null }       
    { listMunicipio.length !== 0 ?
      <FormControl className={classes.formControl} size="small" style={{marginLeft:1+'rem'}} >
        <InputLabel htmlFor="age-native-simple">Municipio</InputLabel>
        <MaterialSelect
          native value={Municipio} onChange={onChangeSelected}
          inputProps={{ name: 'Municipio', id: 'Municipio',}}
        >
          <option aria-label="None" value="" />                     
          {listMunicipio.map((row,index) => (
            <option value={row.Id} key={index} >{row.Nom}</option>
          ))}   
        </MaterialSelect>
      </FormControl>     
    :null  }      
    </Box>  
 
    <Box display={"flex"} width={"100%"}  >     
      <Box style={{width:10+'rem'}} mr={1}>      
        <FormControl component="fieldset" style={{width:10+'rem'}}>    
          <TextField id="outlinedCantidad" variant='outlined'           
            label="RFC"  size="small"
            value={rfc} onChange={onChangeMixto}  
            name="rfc" fullWidth inputProps={{maxLength:12}}
          /> 
        </FormControl>
      </Box>      
      <Box display="flex" style={{width:15+'rem'}} >      
        <FormControl component="fieldset" style={{width:15+'rem'}}>    
          <TextField id="outlinedCantidad" variant='outlined'           
            label="Alias"  size="small"
            value={Alias} onChange={onChangeMixto}  
            name="Alias" fullWidth
          /> 
        </FormControl>
      </Box>       
    </Box>
    <Box width={"100%"} mt={2} >      
      <FormControl component="fieldset" style={{width:"100%"}} >    
        <TextField id="outlinedCantidad" variant='outlined'           
          label="Razón"  size="small"
          value={Razon} onChange={onChangeMixto}  
          name="Razon" fullWidth
        /> 
      </FormControl>
    </Box>        
    <Box width={"100%"}   mt={2}>      
        <FormControl component="fieldset" style={{width:"100%"}} >    
          <TextField id="outlinedCantidad" variant='outlined'           
            label="Responsable"  size="small"
            value={Responsable} onChange={onChangeMixto}  
            name="Responsable" fullWidth
          /> 
        </FormControl>
      </Box>           
    <Box display={"flex"} width={"100%"} mt={2} mb={1}>
             
      <Box style={{ marginRight:".5rem"}}   width={"9rem"}>      
        <FormControl component="fieldset"  >    
          <TextField id="outlinedCantidad" variant='outlined'           
            label="Teléfono "  size="small"
            value={Contacto} onChange={onChangeNumTel}  
            name="Contacto" fullWidth
          /> 
        </FormControl>
      </Box> 
      <Box width={"22rem"}>      
        <FormControl component="fieldset" >    
          <TextField id="outlinedCantidad" variant='outlined'           
            label="Email"  size="small" style={{width:"22rem"}}
            value={email} onChange={onChangeEmail}  
            name="email" fullWidth
          /> 
        </FormControl>
      </Box>                  
    </Box>   
    <Box width={"100%"}>
      <Typography component="p" variant="body2" color='primary' 
        style={{margin:0,marginLeft:.5+'rem', }} >
          Domicilio
      </Typography>   
      <textarea id="Domicilio-input" name="Domicilio" rows="2"
        placeholder="Domicilio" style={{width: "100%",borderRadius:3+'px'}} 
        value={Domicilio} onChange={onChangeFolio} maxLength={500}
      />
    </Box> 
  </form>
  </ModalTam>
  );
}
